const AI_QNA_PATH = /(?:^|\/)assessments\/ai-audit\/[^/?#]+\/qna(?:[/?#]|$)/;
const OBSERVABILITY_PATH = /(?:^|\/)admin\/observability(?:[/?#]|$)/;

function isSensitiveQnaRequest(request) {
    const url = typeof request === 'string' ? request : request?.url;
    return typeof url === 'string' && AI_QNA_PATH.test(url);
}

function shouldLogRequestDiagnostics(buildEnv, request) {
    const url = typeof request === 'string' ? request : request?.url;
    return buildEnv !== 'production' && !isSensitiveQnaRequest(request) && !(typeof url === 'string' && OBSERVABILITY_PATH.test(url));
}

module.exports = {isSensitiveQnaRequest, shouldLogRequestDiagnostics};
